
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'IconButton',
    props: {
        icon: {
            type: String,
            default: ""
        },
        primary: {
            type: Boolean,
            default: false
        },
        secondary: {
            type: Boolean,
            default: false
        },
        raised: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        waitForResponse: {
            type: Boolean,
            default: false
        },
        allowDoubleClick: {
            type: Boolean,
            default: false
        }    
    },
    data(){
        return{
            dblClick: {
                clicks: 0,
                delay: 300,
                timer: 0,
            },            
            loader: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38 38" enable-background="new 0 0 38 38" xml:space="preserve"><g><g transform="translate(1 1)"><circle fill="none" stroke="#486966" stroke-width="2" stroke-opacity="1" cx="18" cy="18" r="18"/><path fill="none" stroke="#ffffff" stroke-width="2" d="M36,18c0-9.9-8.1-18-18-18"><animateTransform  accumulate="none" additive="replace" attributeName="transform" calcMode="linear" dur="1s" fill="remove" from="0 18 18" repeatCount="indefinite" restart="always" to="360 18 18" type="rotate"></animateTransform></path></g></g></svg>',
        }
    },    
    methods: {
        onClick(e : Event) {
            if (!this.allowDoubleClick) {
                if (this.dblClick.clicks > 0) {
                    clearTimeout(this.dblClick.timer)
                    this.dblClick.clicks = 0
                } else {
                    this.dblClick.clicks++
                    this.$emit('onClick')
                    this.dblClick.timer = setTimeout(() => {
                        this.dblClick.clicks = 0
                    }, this.dblClick.delay)
                    e.preventDefault()
                }
            } else {
                e.preventDefault()
                this.$emit('onClick')
            }
        }
    }
})
